interface EnvConfig {
  BASE_URL: string
  CLIENT_ID: string
  DOMAIN: string
  PUSHER_KEY: string
  PUSHER_CLUSTER: string
  INTERCOM_APPID: string
  MAINTAINANCE_MODE: string
  SENTRY_KEY: string
  SENTRY_ENVIRONMENT: string
}

const requiredEnvVars: (keyof EnvConfig)[] = [
  'BASE_URL',
  'CLIENT_ID',
  'DOMAIN',
  'INTERCOM_APPID',
]

export const validateEnvVariables = (): void => {
  const missingVars = requiredEnvVars.filter(
    (key) => !import.meta.env[`VITE_${key}`],
  )

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}`,
    )
  }
}
